import { useEffect, useState } from 'react';
import { apiService } from '../../services/api';

// Qui avance sur quel objectif aujourd'hui (choisi depuis l'accueil) : une seule requête partagée par toutes
// les cartes d'objectifs, rafraîchie au plus toutes les minutes.
const TTL = 60000;
let cache = { at: 0, data: [], promise: null };
const listeners = new Set();

const load = () => {
  if (cache.promise) return cache.promise;
  cache.promise = apiService.get('/home/team-today')
    .then((data) => {
      cache = { at: Date.now(), data: Array.isArray(data) ? data : [], promise: null };
      listeners.forEach((listener) => listener(cache.data));
      return cache.data;
    })
    .catch(() => {
      cache = { ...cache, at: Date.now(), promise: null };
      return cache.data;
    });
  return cache.promise;
};

export const useTeamToday = () => {
  const [data, setData] = useState(cache.data);
  useEffect(() => {
    listeners.add(setData);
    if (Date.now() - cache.at > TTL) load();
    return () => listeners.delete(setData);
  }, []);
  return data;
};

export const refreshTeamToday = () => {
  cache.at = 0;
  return load();
};

export const todayNamesFor = (teamToday, objectiveId) => teamToday
  .filter((entry) => entry.objective_id === objectiveId)
  .map((entry) => (entry.employee_name || '').split(' ')[0])
  .filter(Boolean);
